<div *ngIf="!showModifierPopup" class="detail-content bg-white">
  <div class="bg-wdddhite">

    <div class="row form-group">
      <div class="col-12 ">
        <div class="row">
          <div class="col-12 card p-0 ">
            <img
              [lazyLoad]="itemDetails.imagePath.length > 0 ? itemDetails.imagePath : './assets/images/Itemdefault.jpeg'"
              [defaultImage]="'./assets/images/Itemdefault.jpeg'" class="card-img img-fluid img-item-details"
              alt="Item image">
          </div>

        </div>
        <div class="row">
          <div class="col-12 pl-0 mt-3 ml-4">
            <div class="pl-2 card-title font-weight-bold h6 pt-2 cursor pb-0 mb-0">
              {{languageService.showAltLanguage && itemDetails.itemAlternativeName ?
              ecomservice.htmlUtil.textTruncate(itemDetails.itemAlternativeName,30) :
              ecomservice.htmlUtil.textTruncate(itemDetails.itemName,30)}}
            </div>
            <div class="pl-2 card-title font-weight-bold-500 pt-2 cursor">
              <span class="font-size-14">{{itemDetails.itemDescription}}</span>
            </div>

            <div class="row px-3 line-height-1 pt-2 mb-2px" *ngIf="discountApplied">
              <div class="col">
                <span class="text-primary cursor" (click)="onSignInClick()">
                  <img src="assets/images/homeicons/referral.png" style="width: 7%;height: auto;" alt="">
                  Discount Applied
                </span>
              </div>
            </div>
            <div style="display: none;" class="pl-2 ml-2 discount-box"
              *ngIf="itemDetails.discounts.length > 0 && !discountApplied && !item">
              Select discount option
              <ul class="pl-2 text-break font-color-light-grey mb-0" style="list-style: none;">
                <li *ngFor="let discount of itemDetails.discounts;let i=index;">
                  <div class="col">
                    <div class="row">
                      <div class="col-1 mt-1 cursor">
                        <label class="custom-radio">
                          <input type="radio" name="radioOptions" [id]="'option-' + i" [checked]="discount.selected"
                            (change)="onDiscountChange(itemDetails, discount)">
                          <span class="checkmark"></span>
                        </label>
                      </div>
                      <div class="col">
                        <span class="text-primary cursor fa-xs-small-70">
                          <img src="assets/images/homeicons/discounts.png" style="width: 17px;" alt="">
                        </span>
                        <label class="pl-2 pt-1 text-info cursor">{{discount.discount_name}}</label>
                      </div>
                    </div>
                  </div>

                </li>
              </ul>

            </div>
          </div>
        </div>

        <!-- <div class="row ml-2">
          <div class="col-5 card p-0 ">
            <div class="card-img-overlay p-0 ">
              <div class="input-group flex-nowrap pl-3 cursor mt-2" (click)="onBackClick()">
                <div class="input-group-prepend cursor btn-circle-back text-white border-0 outline-0 box-shadow-none  p-0 px-1">
                  <i class="fas fa fa-chevron-left"></i>
                </div>
              </div>
            </div>
            <img *ngIf="itemDetails.imagePath.length > 0" [src]="itemDetails.imagePath"
                 class="card-img img-fluid img-item-details" alt="location image">
            <img *ngIf="itemDetails.imagePath.length <= 0" src="./assets/images/Itemdefault.jpeg"
                 class="card-img img-fluid img-item-details" alt="location image">
          </div>
          <div class="col-7 pl-0 mt-3">
            <div class="pl-2 card-title font-weight-bold h6 pt-2 cursor pb-0 mb-0">
              {{ecomservice.htmlUtil.textTruncate(itemDetails.itemName,30)}}
            </div>
            <div class="pl-2 card-title font-weight-bold-500 pt-2 cursor">
              <span class="font-size-14">{{itemDetails.itemDescription}}</span>
            </div>
          </div>
        </div> -->

      </div>
    </div>

    <!-- Modifier -->
    <div class="row no-gutters form-group"
      *ngIf="itemDetails.modifierSetList && itemDetails.modifierSetList.length > 0">
      <div class="col">
        <div class="row cursor" *ngFor="let modifier of itemDetails.modifierSetList;let i=index;">
          <div class="col">
            <div class="row bg-light" (click)="onModifierSetClick(modifier,i,modifier.collapsed)"
              [attr.aria-expanded]="modifier.collapsed" aria-controls="modifier.modifierName">
              <div class="col background-grey">
                <div class="row">
                  <div class="col background-grey">
                    <label class="cursor" class="text-dark fw-500 m-0 p-2">
                      {{modifier.modifierCaption ? modifier.modifierCaption : modifier.modifierName}}
                      <span *ngIf="modifier.modifierSetMax">
                        (Pick upto {{modifier.modifierSetMax}})
                      </span>
                    </label>
                  </div>
                  <div class="col-4 background-grey text-right"
                    *ngIf="!modifier.modifierOptions[0].modifiers_into_modifier.length">
                    <label class="m-0 p-2">
                      {{'HOME_PAGE.PRICE' | translate }} ({{settings.company_currency}})
                    </label>
                  </div>
                  <div class="col-1 background-grey"
                    *ngIf="!modifier.modifierOptions[0].modifiers_into_modifier.length">
                    <label class="text-dark m-0 float-right p-2 pt-08 pr-2 cursor">
                      <i class="fas fa-chevron-up float-right" *ngIf="modifier.collapsed"></i>
                      <i class="fas fa-chevron-down float-right" *ngIf="!modifier.collapsed"></i>
                    </label>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <span class="pl-2 text-danger" *ngIf="modifier.errorMessage">
                      {{modifier.errorMessage}}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div id="{{modifier.modifierName}}" [collapse]="modifier.collapsed" [isAnimated]="true" class="container">
              <div class="row border-bottom pt-2" *ngFor="let option of modifier.modifierOptions;let j=index;">
                <ng-container *ngIf="!option.modifiers_into_modifier.length">
                  <!-- <div class="row"> -->
                  <div class="col-1 mt-1 cursor">
                    <div class="round mod-in-mod" *ngIf="option.modifiers_into_modifier">
                      <input [checked]="option.optionSelected" name="{{option.option_pkid}}" type="checkbox"
                        id="{{option.option_pkid}}{{i}}{{j}}"
                        (change)="onModifierOptionChecked($event,modifier,option,i,j)" />
                      <label class="cursor" for="{{option.option_pkid}}{{i}}{{j}}"></label>
                    </div>
                  </div>
                  <div class="col">
                    <label for="{{option.option_pkid}}{{i}}{{j}}"
                      class="pl-2 pt-1 text-dark cursor">{{option.optionName}}
                    </label>
                  </div>
                  <div class="col-3 text-right">
                    <label>

                      {{option.optionPrice.toFixed(2)}}

                    </label>
                  </div>
                  <div class="col-1"></div>
                  <!-- </div> -->
                </ng-container>
                <!-- huhu -->
                <div class="col" *ngIf="option.modifiers_into_modifier.length > 0">
                  <div class="row no-gutters form-group">
                    <div class="col">
                      <div class="row bg-light" (click)="onModifierSetClick2(option,i,option.collapsed)"
                        [attr.aria-expanded]="modifier.collapsed" aria-controls="modifier.modifierName">
                        <div class="col background-grey"
                          [ngClass]="{ 'modifier-selected': option.selectedOptions.length > 0 }">
                          <div class="row">
                            <div class="col background-grey"
                              [ngClass]="{ 'modifier-selected': option.selectedOptions.length > 0 }">
                              <label class="cursor" class="fw-500 m-0 p-2">
                                <!-- {{option.optionName}}-demo-{{option.imm_item_pkid}} -->
                                {{option.optionName}} ({{option.optionPrice}})
                                <span *ngIf="modifier.modifierSetMax">
                                  (Pick upto {{modifier.modifierSetMax}})
                                </span><br>
                                <span *ngIf="option.selectedOptions.length > 0">{{option.selectedOptions.join(', ')}}
                                  selected</span>
                              </label>
                            </div>
                            <div class="col-4 background-grey text-right"
                              [ngClass]="{ 'modifier-selected': option.selectedOptions.length > 0 }">
                              <label class="m-0 p-2">
                                Price ({{settings.company_currency}})
                              </label>
                            </div>
                            <div class="col-1 background-grey"
                              [ngClass]="{ 'modifier-selected': option.selectedOptions.length > 0 }">
                              <label class="text-dark m-0 float-right p-2 pt-08 pr-2 cursor">
                                <i class="fas fa-chevron-up float-right" *ngIf="option.collapsed"></i>
                                <i class="fas fa-chevron-down float-right" *ngIf="!option.collapsed"></i>
                              </label>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col">
                              <span class="pl-2 text-danger" *ngIf="modifier.errorMessage">
                                {{modifier.errorMessage}}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div id="{{modifier.modifierName}}" [collapse]="option.collapsed" [isAnimated]="true"
                        class="container">
                        <div class="row border-bottom pt-2"
                          *ngFor="let option1 of option.modifiers_into_modifier;let z=index;">
                          <div class="col" *ngIf="!option1.modifiers_into_modifier.length">
                            <div class="row">
                              <div class="col-1 mt-1 cursor">
                                <div class="round" *ngIf="option1.modifiers_into_modifier">
                                  <input [checked]="option1.optionSelected" name="{{option1.optionPkid}}"
                                    type="checkbox" id="{{option1.optionPkid}}{{z}}"
                                    (change)="onModifierOptionChecked2($event,modifier,option,i,z, true, option1)" />
                                  <label class="cursor" for="{{option1.optionPkid}}{{z}}"></label>
                                </div>
                              </div>
                              <div class="col">
                                <!-- <label for="{{option1.optionPkid}}{{z}}"
                                  class="pl-2 pt-1 text-dark cursor">why-{{option1.optionName}}-{{option1.optionPkid}}--index--{{z}}--{{i}}</label> -->
                                <label for="{{option1.optionPkid}}{{z}}"
                                  class="pl-2 pt-1 text-dark cursor">{{option1.optionName}}</label>
                              </div>
                              <div class="col-3 text-right">

                                <label>
                                  {{option1.optionPrice}}

                                </label>

                              </div>
                              <div class="col-1"></div>
                            </div>
                          </div>

                          <div class="col" *ngIf="option1.modifiers_into_modifier.length > 0">
                            <div class="row no-gutters form-group">
                              <div class="col">
                                <div class="row cursor">
                                  <div class="col">
                                    <div class="row bg-light" [attr.aria-expanded]="modifier.collapsed"
                                      aria-controls="modifier.modifierName">
                                      <div class="col background-grey">
                                        <div class="row">
                                          <div class="col background-grey">
                                            <label class="cursor" class="text-dark fw-500 m-0 p-2">
                                              {{option.optionName}}
                                              <span *ngIf="modifier.modifierSetMax">
                                                (Pick upto {{childModifier.modifierSetMax}})
                                              </span>
                                            </label>
                                          </div>
                                          <div class="col-3 background-grey text-right">
                                            <label class="m-0 p-2">
                                              Price77 ({{settings.company_currency}})
                                            </label>
                                          </div>
                                          <div class="col-1 background-grey">
                                            <label class="text-dark m-0 float-right p-2 pt-08 pr-2 cursor">
                                              <i class="fas fa-chevron-up float-right" *ngIf="modifier.collapsed"></i>
                                              <i class="fas fa-chevron-down float-right"
                                                *ngIf="!modifier.collapsed"></i>
                                            </label>
                                          </div>
                                        </div>
                                        <div class="row">
                                          <div class="col">
                                            <span class="pl-2 text-danger" *ngIf="modifier.errorMessage">
                                              {{childModifier.errorMessage}}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div id="{{modifier.modifierName}}" [collapse]="modifier.collapsed"
                                      [isAnimated]="true" class="container">
                                      <div class="row border-bottom pt-2"
                                        *ngFor="let option of option.modifiers_into_modifier;let j=index;">
                                        <div class="col" *ngIf="!option.has_modifiers_into_modifier">
                                          <div class="row">
                                            <div class="col-1 mt-1 cursor"
                                              [ngClass]="{'ml-5': option.modifiers_into_modifier}">
                                              <div class="round" *ngIf="option.modifiers_into_modifier">
                                                <input [checked]="option.optionSelected" name="{{option.optionPkid}}"
                                                  type="checkbox" id="{{option.optionPkid}}{{j}}"
                                                  (change)="onModifierOptionChecked($event,modifier,option,i,j)" />
                                                <label class="cursor" for="{{option.optionPkid}}{{j}}"></label>
                                              </div>
                                            </div>
                                            <div class="col">
                                              <label for="{{option.optionPkid}}{{j}}"
                                                class="pl-2 pt-1 text-dark cursor">{{option.optionName}}</label>
                                            </div>
                                            <div class="col-3 text-right">
                                              <label *ngIf="serviceType === 'DINE_IN'">
                                                <span
                                                  *ngIf="option.optionDineInPriceDiscounted === 0">{{option.optionDineInPrice}}</span>
                                                <span *ngIf="option.optionDineInPriceDiscounted > 0">
                                                  <del>{{option.optionDineInPrice}}</del>
                                                  {{option.optionDineInPriceDiscounted}}
                                                </span>
                                              </label>


                                            </div>
                                            <div class="col-1"></div>
                                          </div>
                                        </div>

                                      </div>
                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="row no-gutters form-group">
      <div class="col">
        <div class="row bg-light px-4">
          <div class="col p-2">
            <label class="text-dark fw-500">
              {{'HOME_PAGE.SPECIAL_REQUESTS' | translate }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col px-4 mx-1">
            <textarea class="form-control" rows="3" [placeholder]="('HOME_PAGE.ADD_NOTE' | translate)"
              [(ngModel)]="specialRequest"></textarea>
          </div>
        </div>

      </div>
    </div>

    <!-- <div class="row">
      <div class="col  text-center font-color-dark-grey">
        <label class="h6">Add repeats of the same</label>
      </div>
    </div> -->
    <div class="row no-gutters form-group">
      <div class="col text-center">
        <div *ngFor="let alert of alerts">
          <alert [type]="alert.type" [isOpen]="alert.isOpen" [dismissOnTimeout]="alert.timeout"
            (onClosed)="onClosed(alert)">{{ alert.msg }}</alert>
        </div>
      </div>
    </div>

  </div>
</div>
<div *ngIf="!showModifierPopup" class="detail-footer bg-white">
  <div class="footer-actions">
    <div class="qty-stepper" *ngIf="!discountApplied && !item">
      <button type="button" class="qty-btn" (click)="onItemClick(itemDetails,'MINUS')">
        <i class="fas fa-minus"></i>
      </button>
      <span class="qty-value">{{itemDetails.quantity}}</span>
      <button type="button" class="qty-btn" (click)="onItemClick(itemDetails,'PLUS')">
        <i class="fas fa-plus"></i>
      </button>
    </div>

    <button [disabled]="!itemDetails.itemGuid" type="button" class="add-to-cart-btn" (click)="onAddToCartClick(itemDetails)">
      <span class="label">{{ item ? 'Update' : ('HOME_PAGE.ADD_TO_CART' | translate) }}</span>
      <span class="price" *ngIf="settings">
        {{settings.company_currency}} {{getTotalPrice(itemDetails).toFixed(2)}}
      </span>
    </button>
  </div>
</div>

<ng-template #combinationPopup>

  <div class="modal-body modal-body-promotion d-flex flex-column" *ngIf="!showBuyAndGet">
    <div class="row justify-content-center">
      <div class="centered-content text-center">
        <span class="font-weight-bold-700 h5">LIMITED TIME PROMOTION</span><br>
        <span class="font-weight-bold-700 h5">{{discountCaption}}</span>
      </div>
    </div>

    <div class="row mt-4 justify-content-center">
      <span class="text-white h6"><b>1 x {{itemDetails.itemName}} selected</b></span>
    </div>
    <div class="row mt-1 mb-3 justify-content-center">
      <span class="text-green"><b>Would you consider promotion below?</b></span>
    </div>

    <div class="row mt-1">
      <ng-container *ngIf="combo.length < 3">
        <div [ngClass]="{'col-12': combo.length === 1, 'col-6': combo.length === 2}">
          <ng-container *ngFor="let option of combo; let i = index">
            <div [ngClass]="{ 'mt-2': i === 1 }" class="option" (click)="onOptionSelected(option)"
              [class.selected]="comboSelected === option.optionName">
              <h6 [class.selected]="comboSelected === option.optionName">{{ option.optionName }}</h6><br>
              <span [innerHTML]="option.description"></span><br>
              <span><s>{{ option.originalPrice.toFixed(2) }}</s> {{ option.salePrice.toFixed(2) }}</span>
            </div>
          </ng-container>
        </div>
      </ng-container>
      <!-- 3 items -->
      <ng-container *ngIf="combo.length > 2">
        <!-- Col Left Option 1 và Option 2 -->
        <div class="col-6">
          <ng-container *ngFor="let option of combo; let i = index">
            <div [ngClass]="{ 'mt-2': i === 1 }" class="option" *ngIf="i < 2" (click)="onOptionSelected(option)"
              [class.selected]="comboSelected === option.optionName">
              <h6 [class.selected]="comboSelected === option.optionName">{{ option.optionName }}</h6><br>
              <span [innerHTML]="option.description"></span><br>
              <span><s>{{ option.originalPrice.toFixed(2) }}</s> {{ option.salePrice.toFixed(2) }}</span>
            </div>
          </ng-container>
        </div>

        <!-- Col right Option 3 -->
        <div class="col-6 align-items-center justify-content-center" *ngIf="combo.length > 2">
          <div class="row mb-3 d-flex justify-content-center align-items-center">
            <img width="70px" src="./assets/img/bg/clickhere.png" class="Click here" />
          </div>
          <div class="mt-3 option text-center" (click)="onOptionSelected(combo[2])"
            [class.selected]="comboSelected === combo[2].optionName">
            <h6 [class.selected]="comboSelected === combo[2].optionName">{{ combo[2].optionName }}</h6><br>
            <span [innerHTML]="combo[2].description"></span><br>
            <span><s>{{ combo[2].originalPrice.toFixed(2) }}</s> {{ combo[2].salePrice.toFixed(2) }}</span>
          </div>
        </div>
      </ng-container>

    </div>



    <div class="row mt-auto">

      <div class="col-6">
        <button (click)="closeCombinationPopup()"
          class="deal-button btn btn-outline-secondary btn-block bg-dark text-white box-shadow-none">No,
          thanks!</button>
      </div>
      <div class="col-6">
        <button (click)="handleNext()" [disabled]="!comboSelected"
          class="text-black deal-button btn btn-outline-secondary btn-block bg-dark-blue text-white box-shadow-none">Yes,
          next!</button>
      </div>

    </div>
  </div>


  <div class="modal-body modal-body-promotion d-flex flex-column" *ngIf="showBuyAndGet">
    <div class="row justify-content-center">
      <div class="centered-content text-center">
        <span class="font-weight-bold-700 h5">LIMITED TIME PROMOTION</span><br>
        <span class="font-weight-bold-700 h5">{{discountCaption}}</span>
      </div>
    </div>

    <div class="row mt-4 justify-content-center">
      <span class="text-white h6"><b>1 x {{itemDetails.itemName}} selected</b></span>
    </div>
    <div class="row mt-1 mb-3 justify-content-center">
      <span class="text-green"><b>Would you consider promotion below?</b></span>
    </div>

    <div class="row mt-1">
      <ng-container *ngIf="combo.length < 3">
        <div [ngClass]="{'col-12': combo.length === 1, 'col-6': combo.length === 2}">
          <ng-container *ngFor="let option of combo; let i = index">
            <div [ngClass]="{ 'mt-2': i === 1 }" class="option" (click)="onOptionSelected(option)"
              [class.selected]="comboSelected === option.optionName">
              <h6 [class.selected]="comboSelected === option.optionName">{{ option.optionName }}</h6><br>
              <span [innerHTML]="option.description"></span><br>
              <span>{{ option.originalPrice.toFixed(2) }}</span>
            </div>
          </ng-container>
        </div>
      </ng-container>
      <!-- 3 items -->
      <ng-container *ngIf="combo.length > 2">
        <!-- Col Left Option 1 và Option 2 -->
        <div class="col-6">
          <ng-container *ngFor="let option of combo; let i = index">
            <div [ngClass]="{ 'mt-2': i === 1 }" class="option" *ngIf="i < 2" (click)="onOptionSelected(option)"
              [class.selected]="comboSelected === option.optionName">
              <h6 [class.selected]="comboSelected === option.optionName">{{ option.optionName }}</h6><br>
              <span [innerHTML]="option.description"></span><br>
              <span>{{ option.originalPrice.toFixed(2) }}</span>
            </div>
          </ng-container>
        </div>

        <!-- Col right Option 3 -->
        <div class="col-6 align-items-center justify-content-center">
          <div class="row mb-3 d-flex justify-content-center align-items-center">
            <img width="70px" src="./assets/img/bg/clickhere.png" class="Click here" />
          </div>
          <div class="option text-center" *ngIf="combo.length > 2" (click)="onOptionSelected(combo[2])"
            [class.selected]="comboSelected === combo[2].optionName">
            <h6 [class.selected]="comboSelected === combo[2].optionName">{{ combo[2].optionName }}</h6><br>
            <span [innerHTML]="combo[2].description"></span><br>
            <span>{{ combo[2].originalPrice.toFixed(2) }}</span>
          </div>
        </div>
      </ng-container>

    </div>
    <ng-container *ngFor="let item of buyItems;let i=index;">
      <div class="row item-border-bottom">
        <div class="col-6">
          <div class="pl-2 mt-2 card-title font-weight-bold-500 h6 mb-1">
            {{item.itemName}}
          </div>

        </div>

        <div class="col-4 text-center">
          <div class="input-group justify-content-center mt-2">
            <div class="input-group-prepend">
              <i (click)="subtract2(item,i)"
                class="fas a-lg fa-minus cursor font-color-lights-grey p-2 font-size-price"></i>
            </div>
            <div class="text-dark p-1 bg-light bg-white font-size-price">
              <span>{{item.quantity}}</span>
            </div>
            <div class="input-group-append">
              <i (click)="add2(item,i)" class="fas fa-plus cursor font-color-lights-grey p-2 font-size-price"></i>
            </div>
          </div>
        </div>
        <div class="col-2 pt-2 pl-1">
          <span class="text-primary cursor fa-xs-small-70" *ngIf="isFree">
            <img src="assets/images/homeicons/free2.png" style="width: 17px;" alt="">
          </span>
          <span>
            {{item.priceEach.toFixed(2)}}
          </span>
        </div>
      </div>

    </ng-container>


    <div class="item-get mt-auto" [ngClass]="{'disabled-get-items': !comboSelected}" *ngIf="getItems.length > 0">
      <div class="row">
        <div class="col-12 text-white">
          <label class="h6 pl-2"><b>{{freeTitle}}</b></label>

        </div>
      </div>
      <div *ngFor="let item of getItems;let i=index;" class="row">
        <div class="col-6">
          <div class="pl-2 mt-2 card-title font-weight-bold-500 h6 mb-1">
            {{item.itemName}}
          </div>

        </div>
        <div class="col-6 d-flex justify-content-end">
          <div class="price-col" *ngIf="!isFree">
            <span>
              <s>{{(item.quantity * item.priceEach).toFixed(2)}}</s>
            </span>
            <span class="pl-2">
              {{(item.quantity * item.discountedPrice).toFixed(2)}}
            </span>
          </div>
          <div class="quantity-col" *ngIf="getQuantity !== 1 || getItems.length !== 1">
            <div class="input-group justify-content-center">
              <div class="input-group-prepend">
                <i (click)="subtractFree(item,i)" class="fas a-lg fa-minus cursor p-2 font-size-price"></i>
              </div>
              <div class="p-1 font-size-price">
                <span>{{item.quantity}}</span>
              </div>
              <div class="input-group-append">
                <i (click)="addFree(item,i)" class="fas fa-plus cursor p-2 font-size-price"></i>
              </div>
            </div>
          </div>
        </div>



      </div>

    </div>

    <div class="row custom-modal-footer">

      <div class="col-6">
        <button (click)="closeCombinationPopup()"
          class="deal-button btn btn-outline-secondary btn-block bg-dark text-white box-shadow-none">No,
          thanks!</button>
      </div>
      <div class="col-6">
        <button (click)="handleBuyGetNext()" [disabled]="totalGetItemsSelected === 0"
          class="text-black deal-button btn btn-outline-secondary btn-block bg-dark-blue text-white box-shadow-none">Yes,
          next!</button>
      </div>

    </div>


  </div>
</ng-template>

<div *ngIf="showModifierPopup">
  <div class="col-12">
    <div class="pl-2 mt-2 card-title font-weight-bold-500 h6 mb-1">
      Please select modifier options
    </div>

  </div>
  <div *ngFor="let item of combinationBuyItems;let e=index;trackBy:guid">
    <ng-container *ngIf="item.modifierSetList && item.modifierSetList.length > 0">
      <div class="row item-border-bottom">

        <div class="col-12">
          <div class="pl-2 mt-2 mb-1">
            <ng-container *ngIf="item.isFirstBuy">
              <span>Buy Item</span><br>
            </ng-container>

            <ng-container *ngIf="item.isFirstGet">
              <span>Get Item</span><br>
            </ng-container>
            <span class="card-title font-weight-bold-500 h6">{{item.itemName}}, Quantity {{item.itemIndex}} of
              {{totalModItems}}</span>
          </div>

        </div>

      </div>
      <!-- free modifier -->
      <div class="row no-gutters form-group">
        <div class="col">
          <div class="row cursor" *ngFor="let modifier of item.modifierSetList;let i=index;">
            <div class="col">
              <div class="row bg-light" (click)="onModifierSetClick3(item,modifier,i,modifier.collapsed)"
                [attr.aria-expanded]="modifier.collapsed" aria-controls="modifier.modifierName">
                <div class="col background-grey">
                  <div class="row">
                    <div class="col background-grey">
                      <label class="cursor" class="text-dark fw-500 m-0 p-2">
                        <!-- {{modifier.modifierName}} -->
                        {{modifier.modifierCaption ? modifier.modifierCaption : modifier.modifierName}}
                        <span *ngIf="modifier.modifierSetMax">
                          (Pick upto {{modifier.modifierSetMax}})
                        </span>
                      </label>
                    </div>
                    <div class="col-4 background-grey text-right"
                      *ngIf="!modifier.modifierOptions[0].modifiers_into_modifier.length">
                      <label class="m-0 p-2">
                        Price ({{settings.company_currency}})
                      </label>
                    </div>
                    <div class="col-1 background-grey"
                      *ngIf="!modifier.modifierOptions[0].modifiers_into_modifier.length">
                      <label class="text-dark m-0 float-right p-2 pt-08 pr-2 cursor">
                        <i class="fas fa-chevron-up float-right" *ngIf="modifier.collapsed"></i>
                        <i class="fas fa-chevron-down float-right" *ngIf="!modifier.collapsed"></i>
                      </label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <span class="pl-2 text-danger" *ngIf="modifier.errorMessage">
                        {{modifier.errorMessage}}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div id="{{modifier.modifierName}}" [collapse]="modifier.collapsed" [isAnimated]="true" class="container">
                <div class="row border-bottom pt-2" *ngFor="let option of modifier.modifierOptions;let j=index;">
                  <div class="col" *ngIf="!option.modifiers_into_modifier.length">
                    <div class="row">
                      <div class="col-1 mt-1 cursor">
                        <div class="round" *ngIf="option.modifiers_into_modifier">
                          <input [checked]="option.optionSelected" name="{{option.optionPkid}}-{{e}}" type="checkbox"
                            id="{{option.optionPkid}}-{{e}}"
                            (change)="onCombinationModifierOptionChecked($event,item, modifier,option,i,j, e)" />
                          <label class="cursor" for="{{option.optionPkid}}-{{e}}"></label>
                        </div>
                      </div>
                      <div class="col">
                        <label for="{{option.optionPkid}}-{{e}}"
                          class="pl-2 pt-1 text-dark cursor">{{option.optionName}}</label>
                      </div>
                      <div class="col-3 text-right">
                        <label>

                          {{option.optionPrice.toFixed(2)}}

                        </label>
                      </div>
                      <div class="col-1"></div>
                    </div>
                  </div>
                  <!-- huhu -->
                  <div style="display: none;" class="col" *ngIf="option.modifiers_into_modifier.length > 0">
                    <div class="row no-gutters form-group">
                      <div class="col">
                        <div class="row bg-light" (click)="onModifierSetClick2(option,i,option.collapsed)"
                          [attr.aria-expanded]="modifier.collapsed" aria-controls="modifier.modifierName">
                          <div class="col background-grey"
                            [ngClass]="{ 'modifier-selected': option.selectedOptions.length > 0 }">
                            <div class="row">
                              <div class="col background-grey"
                                [ngClass]="{ 'modifier-selected': option.selectedOptions.length > 0 }">
                                <label class="cursor" class="fw-500 m-0 p-2">
                                  {{option.optionName}}

                                  <span *ngIf="modifier.modifierSetMax">
                                    (Pick upto {{modifier.modifierSetMax}})
                                  </span><br>
                                  <span *ngIf="option.selectedOptions.length > 0">{{option.selectedOptions.join(', ')}}
                                    selected</span>
                                </label>
                              </div>
                              <div class="col-3 background-grey text-right"
                                [ngClass]="{ 'modifier-selected': option.selectedOptions.length > 0 }">
                                <label class="m-0 p-2">
                                  Price ({{settings.company_currency}})gdgd
                                </label>
                              </div>
                              <div class="col-1 background-grey"
                                [ngClass]="{ 'modifier-selected': option.selectedOptions.length > 0 }">
                                <label class="text-dark m-0 float-right p-2 pt-08 pr-2 cursor">
                                  <i class="fas fa-chevron-up float-right" *ngIf="option.collapsed"></i>
                                  <i class="fas fa-chevron-down float-right" *ngIf="!option.collapsed"></i>
                                </label>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col">
                                <span class="pl-2 text-danger" *ngIf="modifier.errorMessage">
                                  {{modifier.errorMessage}}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div id="{{modifier.modifierName}}" [collapse]="option.collapsed" [isAnimated]="true"
                          class="container">
                          <div class="row border-bottom pt-1"
                            *ngFor="let option1 of option.modifiers_into_modifier;let j=index;">
                            <div class="col" *ngIf="!option1.modifiers_into_modifier.length">
                              <div class="row">
                                <div class="col-1 mt-1 cursor">
                                  <div class="round" *ngIf="option1.modifiers_into_modifier">
                                    <input [checked]="option1.optionSelected" name="{{option1.optionPkid}}"
                                      type="checkbox" id="{{option1.optionPkid}}{{j}}"
                                      (change)="onModifierOptionChecked2($event,modifier,option,i,j, true, option1)" />
                                    <label class="cursor" for="{{option1.optionPkid}}{{j}}"></label>
                                  </div>
                                </div>
                                <div class="col">
                                  <label for="{{option1.optionPkid}}{{j}}"
                                    class="pl-2 pt-1 text-dark cursor">{{option1.optionName}}</label>
                                </div>
                                <div class="col-3 text-right">

                                </div>
                                <div class="col-1"></div>
                              </div>
                            </div>

                            <div class="col" *ngIf="option1.modifiers_into_modifier.length > 0">
                              <div class="row no-gutters form-group">
                                <div class="col">
                                  <div class="row cursor">
                                    <div class="col">
                                      <div class="row bg-light" [attr.aria-expanded]="modifier.collapsed"
                                        aria-controls="modifier.modifierName">
                                        <div class="col background-grey">
                                          <div class="row">
                                            <div class="col background-grey">
                                              <label class="cursor" class="text-dark fw-500 m-0 p-2">
                                                {{option.optionName}}
                                                <span *ngIf="modifier.modifierSetMax">
                                                  (Pick upto {{childModifier.modifierSetMax}})
                                                </span>
                                              </label>
                                            </div>
                                            <div class="col-3 background-grey text-right">
                                              <label class="m-0 p-2">
                                                Price ({{settings.company_currency}})
                                              </label>
                                            </div>
                                            <div class="col-1 background-grey">
                                              <label class="text-dark m-0 float-right p-2 pt-08 pr-2 cursor">
                                                <i class="fas fa-chevron-up float-right" *ngIf="modifier.collapsed"></i>
                                                <i class="fas fa-chevron-down float-right"
                                                  *ngIf="!modifier.collapsed"></i>
                                              </label>
                                            </div>
                                          </div>
                                          <div class="row">
                                            <div class="col">
                                              <span class="pl-2 text-danger" *ngIf="modifier.errorMessage">
                                                {{childModifier.errorMessage}}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div id="{{modifier.modifierName}}" [collapse]="modifier.collapsed"
                                        [isAnimated]="true" class="container">
                                        <div class="row border-bottom pt-2"
                                          *ngFor="let option of option.modifiers_into_modifier;let j=index;">
                                          <div class="col" *ngIf="!option.has_modifiers_into_modifier">
                                            <div class="row">
                                              <div class="col-1 mt-1 cursor"
                                                [ngClass]="{'ml-5': option.modifiers_into_modifier}">
                                                <div class="round" *ngIf="option.modifiers_into_modifier">
                                                  <input [checked]="option.optionSelected" name="{{option.optionPkid}}"
                                                    type="checkbox" id="{{option.optionPkid}}{{j}}"
                                                    (change)="onModifierOptionChecked($event,modifier,option,i,j)" />
                                                  <label class="cursor" for="{{option.optionPkid}}{{j}}"></label>
                                                </div>
                                              </div>
                                              <div class="col">
                                                <label for="{{option.optionPkid}}{{j}}"
                                                  class="pl-2 pt-1 text-dark cursor">{{option.optionName}}</label>
                                              </div>
                                              <div class="col-3 text-right">

                                              </div>
                                              <div class="col-1"></div>
                                            </div>
                                          </div>

                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </ng-container>
  </div>
  <div class="row">


    <div class="col-12">
      <button (click)="addCombinationToCart()"
        class="btn btn-outline-secondary btn-block bg-dark-blue text-white box-shadow-none">Add To Cart</button>
    </div>

  </div>
</div>

<app-loading-component></app-loading-component>
<app-toast [message]="toastMessage" [visible]="showToast"></app-toast>